/**
 * Firebase Storage object paths for the Entity Framework.
 *
 * Kept in its own module (rather than alongside the ImageUpload component)
 * because its real counterpart is `backend/storage.rules`, not React — and
 * so the upload path can be unit-tested without mounting a component.
 */

/**
 * Build the Storage object path for an entity photo.
 *
 * MUST stay byte-for-byte compatible with the `match` block in
 * `backend/storage.rules`:
 *
 *     /tenants/{tenantId}/entities/{entityType}/{entityId}/{fileName}
 *
 * The literal `entities/` segment is load-bearing. Omitting it — as
 * ImageUpload did between 11E.3 and this fix — makes every upload fall
 * through to the deny-all rule and fail with `storage/unauthorized`.
 */
export function entityPhotoPath(
  tenantId: string,
  entityType: string,
  entityId: string,
  fileName = 'photo.jpg',
): string {
  return `tenants/${tenantId}/entities/${entityType}/${entityId}/${fileName}`;
}
